module.exports = __webpack_public_path__ + "static/media/drStrange.702ce087.jpeg";